module.exports = __webpack_public_path__ + "img/democratic-republic-of-congo.9c29bd11.png";